<template>
  <div class="container">
    <Dashboard :data="cardTag" />
  </div>
</template>

<script>
import Dashboard from "../../components/admin/Dashboard";
import { dbFs } from "@/modules/database";
import { mapGetters } from "vuex";

export default {
  components: {
    Dashboard
  },
  data() {
    return {
      orders: [],
      cardTag: [
        {
          tag: "Assign To Deliver",
          theme: "success",
          icon: "file",
          count: 0
        },
        {
          tag: "Start Delivery",
          theme: "warning",
          icon: "pause",
          count: 0
        },
        {
          tag: "Total Delivered",
          theme: "danger",
          icon: "database",
          count: 0
        }
      ]
    };
  },
  mounted() {
    this.setupFirebaseReading();
  },
  computed: {
    ...mapGetters({
      vendorId: "getVendorId",
      user: "getUser"
    })
  },
  methods: {
    setupFirebaseReading: function() {
      if (this.user) {
        this.loading = true;
        this.$bind(
          "orders",
          dbFs.collection("order").where("delivery", "==", this.user.uid)
        )
          .catch(error => {
            this.loading = false;
            console.log(error);
          })
          .finally(() => {
            this.loading = false;
            this.CheckAll();
          });
      }
    },
    getLastOrderStatus(status) {
      let lastarr = status.slice(-1)[0];
      return [lastarr];
    },
    CheckAll() {
      this.cardTag[0].count = this.getOrderByStatus(
        2,
        "deliveryStatus",
        false
      ).length;
      this.cardTag[1].count = this.getOrderByStatus(
        2,
        "deliveryStatus",
        true
      ).length;
      this.cardTag[2].count = this.getOrderByStatus(3).length;
    },
    getOrderByStatus(type, current = "", asper = "") {
      let status = "";
      let newOrderList = [];
      this.orders.forEach(order => {
        status = this.getLastOrderStatus(order.status);
        if (status[0].type == type) {
          switch (current) {
            case "packStatus":
              if (order.packStatus == asper) {
                newOrderList.push(order);
              }
              break;
            case "deliveryStatus":
              if (order.deliveryStatus == asper) {
                newOrderList.push(order);
              }
              break;
            default:
              newOrderList.push(order);
              break;
          }
        }
      });
      return newOrderList;
    }
  },
  watch: {
    user() {
      this.setupFirebaseReading();
    }
  }
};
</script>

<style></style>
